import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import { Avatar, ComponentWrapper, Stack } from 'ascential-horizon'
import getThemeConfig from '../../providers/config/themeConfig'
import { trackLinkClick } from '../../services/tracking'

const TalentList = ({ speakers }) => {
  const {
    speakers: { pathSingular },
    videoPlatform: { pagePrefix },
  } = getThemeConfig()
  const prefixPath = pagePrefix ? `/${pagePrefix.slug}/` : '/'
  return (
    <ComponentWrapper columnWidth={12}>
      <Stack space="large">
        {speakers &&
          speakers.map((speaker) => {
            const url = `${prefixPath}${pathSingular}/${speaker.slug}`
            return (
              <div key={speaker.id}>
                <Link
                  onClick={() => trackLinkClick(speaker.name, url, 'card')}
                  to={url}>
                  <Avatar {...speaker} image={{ src: speaker.image }} />
                </Link>
              </div>
            )
          })}
      </Stack>
    </ComponentWrapper>
  )
}

TalentList.propTypes = {
  speakers: PropTypes.arrayOf(PropTypes.object),
}

TalentList.defaultProps = {
  speakers: [],
}

export default TalentList
